import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Box, Grid, Button, TextField, FormControl, InputLabel, Select, Autocomplete, MenuItem, Paper, Typography, InputAdornment
} from "@mui/material";
import { toast } from "react-toastify";
import moment from "moment";
import axiosInstance from "../../../lib/axios";
import UnLock from "../../../GlobalFunction/UnLock";
import SearchIcon from '@mui/icons-material/Search';
import {
  Add as AddIcon,
} from "@mui/icons-material";
import RefreshIcon from '@mui/icons-material/Refresh';
import { getUserWisePropertydata } from '../../../Api/PropertyMst/Api'
import CustomAutocomplete from "../../AutoComplete/AutocompletewithoutIcon";

const StoreStep1 = ({
  index, mode, CompanyData, AllTextDisabled, stepToNext, AllfieldStepperData,
  Flag, fetchGoodsData, IsuId, addModeDis, viewModeDis,
}) => {
  const { register, setValue, reset, watch, handleSubmit } = useForm({
    defaultValues: {
      PropertyId: '',
      IsuNo: '',
      IsuDt: moment().format("YYYY-MM-DD"),
      RefNo: '',
      PartyId: '',
      PartyDtlId: '',
      ShPartyId: '',
      ShPartyDtlId: '',
      BillNo: '',
      BillDt: moment().format("YYYY-MM-DD"),
      Amount: "0.00",
      IsuQty: "0.00",
       Remark: '',
    },
  });
 
  const [supplierDrp, setSupplierDrp] = useState([]);
  const [branchDrp, setBranchDrp] = useState([]);
  const [todayDate] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const [actualBranchDrp, setActualBranchDrp] = useState([]);
  const userId = sessionStorage.getItem('UserId');
  const [propoption, setPropoption] = useState([])
  const [selectedProperty, setSelectedProperty] = useState(null);
  console.log('AllfieldStepperData', AllfieldStepperData)

  const openNewTab = () => {
    window.open("/partymaster");
  };
 
  const openBranchTab = ()=>{
    window.open("");
  }
  const handleRefreshSuppliers = () => {
    fetchSuppliers();
  };


  console.log("AllfieldStepperData step 1", AllfieldStepperData)

  useEffect(() => {
    const initializeForm = () => {
      if (mode === "view" && CompanyData.length > 0) {
        const data = CompanyData[0];
        resetFunc(data);
        console.log("API", CompanyData[0]);
      } else if (mode === "add") {
        if (!Flag) {
          resetFunc({ Amount: "0.00", IsuQty: "0.00" });
        } else {
          resetFunc(AllfieldStepperData);
        }
      } else if (mode === "edit") {
        resetFunc(AllfieldStepperData);
      }
    };
    if (propoption.length > 0) {
      initializeForm();
    }
  }, [CompanyData, mode, Flag, AllfieldStepperData, propoption]);

  useEffect(() => {
    fetchSuppliers()
    
  }, []);

  const fetchSuppliers = async () => {
    try {
      const response = await axiosInstance.post("PartyMst/getPartyMstdrp", {
        PartyCat: "SU",
      });
      if (response.data.Status === 0) {
        setSupplierDrp(response.data.Data || []);
      } else {
        toast.info(response.data.Message || "No suppliers found");
      }
    } catch (error) {
      console.error("Supplier fetch error:", error);
      toast.error("Failed to fetch suppliers");
    }
  };

  const fetchBranches = async (supplierId) => {
    if (!supplierId) {
      setBranchDrp([]);
      setValue("PartyDtlId", "");
      setValue("ShPartyDtlId", "");
      return;
    }
    try {
      setLoading(true);
      const response = await axiosInstance.post("PartyMst/getdrpPartyMstDtl", {
        PartyId: supplierId,
      });
      if (response.data.Status === 0) {
        const branches = response.data.Data || [];
        setBranchDrp(branches);
        if (branches.length > 0) {
          setValue("PartyDtlId", branches[0].Id);
        }

      } else {
        toast.info(response.data.Message || "No branches found for this supplier");
        setBranchDrp([]);
        setValue("PartyDtlId", "");
      }
    } catch (error) {
      console.error("Branch fetch error:", error);
      toast.error("Failed to fetch branches");
      setBranchDrp([]);
      setValue("PartyDtlId", ""); // Clear on error
      setValue("ShPartyDtlId", "");
    } finally {
      setLoading(false);
    }
  };
  const fetchActualBranches = async (supplierId) => {
    if (!supplierId) {
      setActualBranchDrp([]);
      setValue("ShPartyDtlId", "");
      return;
    }
    try {
      setLoading(true);
      const response = await axiosInstance.post("PartyMst/getdrpPartyMstDtl", {
        PartyId: supplierId,
      });

      if (response.data.Status === 0) {
        const branches = response.data.Data || [];
        setActualBranchDrp(branches);

        // Auto-select first branch if available
        if (branches.length > 0) {
          setValue("ShPartyDtlId", branches[0].Id);
        }
      } else {
        toast.info(response.data.Message || "No branches found for actual supplier");
        setActualBranchDrp([]);
        setValue("ShPartyDtlId", "");
      }
    } catch (error) {
      console.error("Actual branch fetch error:", error);
      toast.error("Failed to fetch actual branches");
      setActualBranchDrp([]);
      setValue("ShPartyDtlId", "");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === "PartyId" && value.PartyId) {
        setValue("ShPartyId", value.PartyId);
        fetchBranches(value.PartyId);
        // Also fetch branches for actual supplier (which is now same as main)
        fetchActualBranches(value.PartyId);
      }

    });
    return () => subscription.unsubscribe();
  }, [watch]);
 
  useEffect(() => {
    if (branchDrp.length > 0 && !watch("PartyDtlId")) {
      const firstBranchId = branchDrp[0].Id;
      setValue("PartyDtlId", firstBranchId);
      setValue("ShPartyDtlId", firstBranchId); 
    } else if (branchDrp.length === 0) {
      setValue("PartyDtlId", "");
      setValue("ShPartyDtlId", "");
    }
  }, [branchDrp, setValue, watch]);

  const resetFunc = (data = {}) => {
    const partyId = data.PartyId || "";
    const partyDtlId = data.PartyDtlId || "";
    const shPartyId = data.ShPartyId || ""; 
    const shPartyDtlId = data.ShPartyDtlId || "";
    const propId = data.PropId;
  
    const propertyToSelect = propoption.find(prop => prop.id === propId) || null;
    reset({
      IsuNo: data.IsuNo || "",
      IsuDt: data.IsuDt ? moment(data.IsuDt).format("YYYY-MM-DD") : todayDate,
      RefNo: data.RefNo || "",
      PartyId: partyId,
      PartyDtlId: partyDtlId,
      ShPartyId: shPartyId,
      ShPartyDtlId: shPartyDtlId,
      BillNo: data.BillNo || "",
      BillDt: data.BillDt ? moment(data.BillDt).format("YYYY-MM-DD") : todayDate,
      Amount: data.Amount !== undefined ? String(data.Amount) : "0.00",
      IsuQty: data.IsuQty !== undefined ? String(data.IsuQty) : "0.00",
      Remark: data.Remark || "",
      PropertyId: propId,
    });
    if (propertyToSelect) {
      setSelectedProperty(propertyToSelect);
    } else if (propoption.length > 0) {
      setSelectedProperty(propoption[0]);
      setValue("PropertyId", propoption[0].id);
    }
    if (partyId) {
      fetchBranches(partyId);
    } else {
      setBranchDrp([]);
    }
    if (shPartyId) {
      fetchActualBranches(shPartyId);
    } else {
      setActualBranchDrp([]);
    }
  };

  const onSubmit = (data) => {
    if (!data.PartyId) {
      toast.error("Please fill all mandatory fields");
      return;
    }
    stepToNext({
      ...data,
      PropertyId: parseInt(data.PropertyId) || 0,
      PropertyName: selectedProperty?.name || "",
      PartyId: parseInt(data.PartyId),
      PartyDtlId: parseInt(data.PartyDtlId) || 0,
      ShPartyId: parseInt(data.ShPartyId) || 0,
      ShPartyDtlId: parseInt(data.ShPartyDtlId) || 0,
      Amount: parseFloat(data.Amount) || 0,
      IsuQty: parseFloat(data.IsuQty) || 0,
    });
  };

  const handleCancel = async () => {
    try {
      if ((mode === "add" || mode === "edit") && IsuId !== -1) {
        await UnLock(IsuId, "TrnIsu", "IsuId");
      }
      viewModeDis();
      if (CompanyData.length > 0) {
       
        await fetchGoodsData(IsuId, "R");
      } else {
        await fetchGoodsData(1, "L");
      }
    } catch (error) {
      console.error("Cancel error:", error);
      toast.error("Failed to cancel operation");
    }
  };

  // const handleSupplierChange = async (e) => {
  //   const selectedSupplierId = e.target.value;
  //   setValue("PartyId", selectedSupplierId);
  // };
  // const handleBranchChange = (e) => {
  //   const selectedBranchId = e.target.value;
  //   setValue("ShPartyDtlId", selectedBranchId);
  // };
  const handleSupplierChange = (event) => {
    const { name, value } = event.target;
    setValue(name, value);
  };
   const handleBranchChange = (event) => {
    const {name,value} = event.target;
    setValue(name, value);
  };

   // const handleActualSupplierChange = async (e) => {
  //   const selectedSupplierId = e.target.value;
  //   setValue("ShPartyId", selectedSupplierId);
  //   await fetchActualBranches(selectedSupplierId);
  //   setValue("ShPartyDtlId", "");
  // };
  const handleActualSupplierChange = async (event) => {
    const { name, value } = event.target;
    setValue(name, value); // sets ShPartyId
    await fetchActualBranches(value); // fetches branches for selected supplier
    setValue("ShPartyDtlId", ""); // clears dependent dropdown
  };
  
//   const handleActualBranchChange = (e) => {
//     const selectedBranchId = e.target.value;
//     setValue("ShPartyDtlId", selectedBranchId);
// };
const handleActualBranchChange = (event) => {
  const {name,value} = event.target;
  setValue(name, value);
};

// const handlePropertyChange = (event) => {
//   const { name, value } = event.target;
//   const selected = propoption.find((opt) => opt.Id === value) || '';
//  console.log("selectedproperty",selected)
//   setSelectedProperty(selected);
//   setValue(name, value); 
// };


  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const response = await getUserWisePropertydata({
          Flag: "",
          UserId: userId,
        });
        if (response?.data?.Status === 0) {
          const propertyItems = response.data.Data.map((item) => ({
            id: item.PropId,
            name: item.Name,
          }));
          setPropoption(propertyItems);
          // if (propertyItems.length > 0) {
          //   setSelectedProperty(propertyItems[0]);
          // }
        }
      } catch (error) {
        toast.error("Error fetching property data");
      }
    };

    fetchDropdownData();
  }, [userId]);
  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === "PropertyId" && value.PropertyId) {
        const property = propoption.find(prop => prop.id == value.PropertyId);
        if (property) {
          setSelectedProperty(property);
        }
      }
      if (name === "ShPartyId" && value.ShPartyId) {
        fetchActualBranches(value.ShPartyId);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, propoption]);
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2} justifyContent="center" sx={{paddingTop:'0px'} }>
        <Grid item xs={12} md={8} lg={8} >
          <Paper elevation={0} sx={{ p: 3, borderRadius: 0 ,border:"none",paddingTop:'0px !important'}}>
            <Box sx={{ mb: 1 }} gap={0}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Autocomplete
                    id="property-selector"
                    options={propoption}
                    getOptionLabel={(option) => option.name || ""}
                    value={selectedProperty}
                    onChange={(event, newValue) => {
                      setSelectedProperty(newValue);
                      setValue("PropertyId", newValue?.id || "");
                    }}
                    disabled={AllTextDisabled}
                    noOptionsText="No properties found"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                         variant = "filled"
                    className = "custom-textfield"
                        size="small"
                        label={
                          <>
                            Property
                            <span style={{ color: "red", marginLeft: 4 }}>*</span>
                          </>
                        }
                        placeholder="Search property..."
                     
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 1,
                            backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                          }
                        }}
                      />
                    )}
                  />  
                  {/* <CustomAutocomplete
  id="property-selector"
  name="PropertyId"
  label={
    <span>
      Property <span style={{ color: "red", marginLeft: 4 }}>*</span>
    </span>
  }
  options={propoption}
  value={selectedProperty || ''} // local state value
  onChange={handlePropertyChange}
  disabled={AllTextDisabled}
/> */}


                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    label="Isu No"
                    name="IsuNo"
                     variant = "filled"
                    className = "custom-textfield"
                    size="small"
                    {...register("IsuNo")}
                    // disabled={AllTextDisabled}
                    disabled={true}
                    InputLabelProps={{
                      shrink: !!watch("IsuNo"),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        backgroundColor: 'action.disabledBackground'
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    label="Isu Date"
                    name="IsuDt"
                    type="date"
                    value={watch("IsuDt")}
                    InputLabelProps={{ shrink: true }}
                     variant = "filled"
                    className = "custom-textfield"
                    size="small"
                    disabled={AllTextDisabled}
                    {...register("IsuDt")}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    label="Reference No"
                    name="RefNo"
                     variant = "filled"
                    className = "custom-textfield"
                    size="small"
                    {...register("RefNo")}
                    disabled={AllTextDisabled}
                    InputLabelProps={{ shrink: Boolean(watch("RefNo")) }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ mb: 1 }} gap={0}> 
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
             
                 
                  <CustomAutocomplete
                    id="supplierName-select"
                    name="PartyId"
                    label={
                      <span>
                        Supplier From <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    options={supplierDrp}
                    value={supplierDrp.find((supplier) => supplier.Id === watch("PartyId")) || ''}
                    onChange={handleSupplierChange}
                    disabled={AllTextDisabled || loading}
                  />

                </Grid>
                <Grid item xs={12} md={6}>
                 
                    <CustomAutocomplete
                    id="branch-select"
                    name="PartyDtlId"
                    label={
                      <span>
                        Branch <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    options={branchDrp}
                    value={branchDrp.find((branch) => branch.Id === watch("PartyDtlId")) || ''}
                    onChange={handleBranchChange}
                    disabled={AllTextDisabled || loading}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                 
                      <CustomAutocomplete
                    id="ctual-supplier-autocomplete"
                    name="ShPartyId"
                    label={
                      <span>
                Actual Supplier From <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    options={supplierDrp}
                    value={supplierDrp.find((supplier) => supplier.Id === watch("ShPartyId")) || ''}
                    onChange={handleActualSupplierChange}
                    disabled={AllTextDisabled || loading}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  {/* <FormControl variant="outlined" fullWidth size="small">
                    <InputLabel id="ShPartyDtlId-select-label">Actual Branch</InputLabel>
                    <Select
                      labelId="ShPartyDtlId-select-label"
                      id="ShPartyDtlId"
                      value={watch("ShPartyDtlId") || ""}
                      onChange={handleActualBranchChange}
                      disabled={AllTextDisabled || loading || actualBranchDrp.length === 0}
                      label="Actual Branch"
                    >
                      {actualBranchDrp.map((branch) => (
                        <MenuItem key={branch.Id} value={branch.Id}>
                          {branch.Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                     <CustomAutocomplete
                    id="ShPartyDtlId-select"
                    name="ShPartyDtlId"
                    label={
                      <span>
                    Actual Branch <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    options={actualBranchDrp}
                    value={actualBranchDrp.find((branch) => branch.Id === watch("ShPartyDtlId")) || ''}
                    onChange={handleActualBranchChange}
                    disabled={AllTextDisabled || loading}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ mb: 1 }} gap={0}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Bill No."
                    name="BillNo"
                     variant = "filled"
                    className = "custom-textfield"
                    size="small"
                    {...register("BillNo")}
                    disabled={AllTextDisabled}
                    InputLabelProps={{ shrink: Boolean(watch("BillNo")) }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                     variant = "filled"
                    className = "custom-textfield"
                    label="Bill Date"
                    name="BillDt"
                    type="date"
                    value={watch("BillDt")}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    disabled={AllTextDisabled}
                    {...register("BillDt")}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    variant = "filled"
                    className = "custom-textfield"
                    label="IsuQty"
                    name="IsuQty"
                    type="number"                 
                    size="small"
                    step="0.01"
                    {...register("IsuQty")}
                    disabled={AllTextDisabled}
                    // disabled={true}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        backgroundColor: 'action.disabledBackground'
                      }
                    }}
                 
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Amount"
                    name="Amount"
                    type="number"
                    variant = "filled"
                    className = "custom-textfield"
                    size="small"
                    step="0.01"
                    {...register("Amount")}
                     disabled={AllTextDisabled}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        backgroundColor: 'action.disabledBackground'
                      }
                    }}
                  />
                </Grid>
 
              </Grid>
            </Box>

            <Box sx={{ mb: 1}} gap={0}>
              <Grid container spacing={2}>  
                <Grid item xs={12} md={12}>
                  <TextField
                    fullWidth
                    label="Remark"
                    name="Remark"
                     variant = "filled"
                    className = "custom-textfield"
                    size="small"
                    multiline
                    rows={2}
                    {...register("Remark")}
                    disabled={AllTextDisabled}
                    InputLabelProps={{ shrink: Boolean(watch("Remark")) }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        backgroundColor: AllTextDisabled ? 'action.disabledBackground' : 'background.paper'
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 1 }}>
              <Button
                type="submit"
                variant="contained"
                size="medium"
                disabled={AllTextDisabled || loading}
                sx={{
                  px: 3,
                  fontWeight: 600,
                  borderRadius: 1,
                  boxShadow: 'none',
                  '&:hover': { boxShadow: 'none' }
                }}
              >
                Next
              </Button>
              <Button
                variant="outlined"
                size="medium"
                onClick={handleCancel}
                disabled={AllTextDisabled || loading}
                sx={{
                  px: 3,
                  fontWeight: 600,
                  borderRadius: 1,
                  borderWidth: 2,
                  '&:hover': { borderWidth: 2 }
                }}
              >
                Cancel
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </form>
  );
};

export default StoreStep1;